import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Card, Text } from '../../Atoms';
function TemplateAddBeneficiaireStep1 (props) {
  
  
  return (
    <div className='template-scroll cartetp-container'>
      <div className='cartetp-header-container'>
        <Text text='Profil' type='h4' />
      </div>
      <div className='profile-title'>
        <Text text='Ajouter des bénéficiaires' className='profile-sub-title' />
      </div>
      <div className='profile-title'>
        <Text
          text='Pour lequel de vos contrats souhaitez-vous ajouter des bénéficiaires ?'
          type='h7'
        />
      </div>
      <div className='profile-card-container'>
        <Row>
          {props.state.contracts.map(element => <Col className='container-card-profile scale-up-center' md={6} xs={6}>
            <Card
              text={element.name}
              size='medium'
              onClick={() =>
                props.onSelectTypeBeneficiaire(element)
              }
            />
          </Col>)}
         
          
        </Row>
      </div>
    </div>
  );
}

export default TemplateAddBeneficiaireStep1;
